<template>
  <div class="h-screen">
    <div id="gjs" />
  </div>
</template>

<script>
import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';
import grapesJSMJML from 'grapesjs-mjml';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    if (document.getElementById('ckeditor')) {
      this.initializeEditor();
      return;
    }

    const ckeditorScript = document.createElement('script');
    ckeditorScript.setAttribute('id', 'ckeditor');
    ckeditorScript.setAttribute('src', 'https://cdn.ckeditor.com/4.16.1/full-all/ckeditor.js');

    const vm = this;
    ckeditorScript.onload = () => {
      vm.initializeEditor();
    };

    document.head.appendChild(ckeditorScript);
  },
  methods: {
    initializeEditor() {
      this.editor = grapesjs.init({
        container: '#gjs',
        fromElement: false,
        components: '<mjml><mj-body></mj-body></mjml>',
        height: '100%',
        width: 'auto',
        storageManager: false,
        plugins: [grapesJSMJML],
      });

      function toHtml(opts) {
        return this.getInnerHTML(opts);
      }

      this.editor.getWrapper().toHTML = toHtml;

      const vm = this;
      this.editor.Panels.addButton('options', [
        {
          id: 'save',
          className: 'fa fa-floppy-o icon-blank',
          // eslint-disable-next-line no-alert
          command(/** editor, sender */) {
            // console.log(editor.storeData());
            // console.log(editor.runCommand('mjml-get-code').html);
          },
          attributes: { title: 'Save Template' },
        },
        {
          id: 'exit',
          className: 'fa fa-sign-out icon-blank',
          command(/** editor, sender */) {
            vm.$router.replace({
              name: 'accounts.show',
              params: {
                accountId: vm.accountId,
              },
            });
          },
          attributes: { title: 'Exit' },
        },
      ]);
    },
  },
};
</script>
